import ManagerLayout from '../components/ManagerLayout'
import AsyncRoute from '../components/AsyncRoute'
import { Redirect, Switch } from 'react-router-dom'

export interface ManagerRoutesProps {}

function ManagerRoutes({}: ManagerRoutesProps) {
  return (
    <ManagerLayout>
      <Switch>
        <AsyncRoute path='/settings' page='manager/Settings' />
        <AsyncRoute exact path='/dashboard' page='manager/Dashboard' />
        <AsyncRoute exact path='/products' page='manager/Products' />
        <AsyncRoute path='/product/:id' page='manager/Product' />
        <Redirect to='/dashboard' />
      </Switch>
    </ManagerLayout>
  )
}

export default ManagerRoutes
